<template>
  <v-menu
      v-model="menu"
      offset-y
      :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <TextField
            theme="3"
            class="picker-field"
            :clearable="true"
            :readonly="true"
            :label="label"
            min-width="235px"
            max-width="235px"
            :value="value"
            @onClear="eventClear"
        ></TextField>
      </div>
    </template>
    <v-time-picker
        color="var(--theme-color-one)"
        format="24hr"
        :value="value"
        @input="eventInput"
    ></v-time-picker>
  </v-menu>
</template>

<script>
import TextField from "./TextField"

export default {
  name: "DatePicker",
  components: {
    TextField
  },
  props: {
    value: {
      default: undefined
    },
    label: {
      default: ''
    }
  },
  data () {
    return {
      menu: false
    }
  },
  methods: {
    eventInput (val) {
      this.$emit('onInput', val)
    },
    eventClear () {
      this.$emit('onClear')
    }
  }
}
</script>

<style scoped>

</style>